import { Device } from '../interface';

/**
 * Get device with id
 */
export const getDeviceWithId = (devices: Device[], deviceId: string): Device => {
    return devices.find(device => device.id === deviceId);
};
